import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert, Spinner } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { supabase } from "../supabaseClient/supabaseClient";
import { FaUser, FaEnvelope, FaLock, FaCheckCircle, FaEnvelopeOpenText } from "react-icons/fa";
import "./Uyeol.css";

const Uyeol = () => {
  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectPath = queryParams.get("redirect");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setErrorMsg(null);

    // Validations
    if (!termsAccepted) {
      setErrorMsg("Lütfen kullanım koşullarını kabul edin.");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setErrorMsg("Şifreler birbiriyle uyuşmuyor.");
      return;
    }

    if (formData.password.length < 6) {
      setErrorMsg("Şifre en az 6 karakter olmalıdır.");
      return;
    }

    if (formData.username.trim().length < 3) {
      setErrorMsg("Kullanıcı adı en az 3 karakter olmalıdır.");
      return;
    }

    setLoading(true);

    try {
      // 1. Supabase Register
      const { error } = await supabase.auth.signUp({
        email: formData.email,
        password: formData.password,
        options: {
          data: {
            full_name: formData.name,
            username: formData.username.trim(),
          },
          emailRedirectTo: window.location.origin + "/HesapOnaylandi" + (redirectPath ? `?redirect=${redirectPath}` : "")
        },
      });

      if (error) throw error;

      setIsSuccess(true);

    } catch (error) {
      if (error.message.includes("already registered")) {
        setErrorMsg("Bu e-posta adresiyle zaten bir kayıt mevcut.");
      } else {
        setErrorMsg("Kayıt sırasında bir hata oluştu: " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-wrapper">
      <div className="auth-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>

      <Container className="auth-container">
        <Row className="justify-content-center">
          <Col md={8} lg={6} xl={5}>
            <div className="auth-card shadow-2xl">

              {/* HEADER SECTION */}
              <div className="auth-header text-center mb-4">
                <h2 className="auth-title">Aramıza Katıl</h2>
                <p className="auth-subtitle">Saniyeler içinde hesabınızı oluşturun</p>
              </div>

              {/* --- BAŞARILI DURUM EKRANI --- */}
              {isSuccess ? (
                <div className="success-state text-center py-4">
                  <div className="success-icon-wrapper mb-4">
                    <FaEnvelopeOpenText className="success-icon" />
                  </div>
                  <h3 className="fw-bold text-success mb-3">Kayıt Başarılı!</h3>

                  <div className="demo-gift-box mb-4">
                    <h5 className="fw-bold mb-2">Hesabınızı Onaylayın</h5>
                    <p className="mb-0 small">
                      Lütfen <strong>{formData.email}</strong> adresine gönderdiğimiz onay e-postasındaki doğrulama butonuna tıklayın. 
                      Hesabınız onaylandıktan sonra 1 günlük demo süreniz otomatik olarak tanımlanacaktır.
                    </p>
                  </div>

                  <p className="text-muted mb-4 small">
                    (Spam / gereksiz klasörünü kontrol etmeyi unutmayın)
                  </p>

                  <Button
                    className="auth-submit-btn w-100"
                    onClick={() => navigate("/Uyegirisi")}
                  >
                    Giriş Sayfasına Git
                  </Button>
                </div>
              ) : (
                /* --- KAYIT FORMU --- */
                <>
                  {errorMsg && (
                    <Alert variant="danger" className="auth-alert border-0 shadow-sm d-flex align-items-center">
                      {errorMsg}
                    </Alert>
                  )}

                  <Form onSubmit={handleRegister} className="auth-form">
                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="auth-label">Ad Soyad</Form.Label>
                          <div className="input-with-icon">
                            <FaUser className="input-icon" />
                            <Form.Control id="name" type="text" placeholder="Ad Soyad" onChange={handleChange} required className="auth-input" />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="auth-label">Kullanıcı Adı</Form.Label>
                          <div className="input-with-icon">
                            <span className="input-icon fw-bold">@</span>
                            <Form.Control id="username" type="text" placeholder="Kullanıcı Adı" onChange={handleChange} required className="auth-input" />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label className="auth-label">E-posta Adresi</Form.Label>
                      <div className="input-with-icon">
                        <FaEnvelope className="input-icon" />
                        <Form.Control id="email" type="email" placeholder="ornek@mail.com" onChange={handleChange} required className="auth-input" />
                      </div>
                    </Form.Group>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="auth-label">Şifre</Form.Label>
                          <div className="input-with-icon">
                            <FaLock className="input-icon" />
                            <Form.Control id="password" type="password" placeholder="••••••••" onChange={handleChange} required className="auth-input" />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label className="auth-label">Şifre Tekrar</Form.Label>
                          <div className="input-with-icon">
                            <FaCheckCircle className="input-icon" />
                            <Form.Control id="confirmPassword" type="password" placeholder="••••••••" onChange={handleChange} required className="auth-input" />
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Form.Group className="mb-4 mt-2">
                      <Form.Check
                        type="checkbox"
                        id="terms"
                        label={
                          <span className="text-muted small">
                            <a href="/sozlesme/gizlilik" target="_blank" rel="noopener noreferrer" className="auth-link" style={{ fontSize: 'inherit' }}>Kullanım koşullarını ve gizlilik politikasını</a> kabul ediyorum
                          </span>
                        }
                        checked={termsAccepted}
                        onChange={(e) => setTermsAccepted(e.target.checked)}
                        className="auth-checkbox"
                      />
                    </Form.Group>

                    <Button
                      type="submit"
                      disabled={loading}
                      className="auth-submit-btn w-100 mb-4"
                    >
                      {loading ? (
                        <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" /> Kaydediliyor...</>
                      ) : (
                        "Ücretsiz Kayıt Ol"
                      )}
                    </Button>
                  </Form>

                  <div className="auth-footer text-center">
                    <p className="text-muted mb-0">
                      Zaten hesabınız var mı?{' '}
                      <Link to="/Uyegirisi" className="auth-link fw-bold">
                        Giriş Yap
                      </Link>
                    </p>
                  </div>
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Uyeol;